import { useCallback, useEffect } from 'react';

import { useDialog } from 'modules/common/hooks/useDialog';
import {
  hasMaintenanceDialogBeenShown,
  setMaintenanceDialogAsShown,
} from 'modules/common/utils/maintenanceUtils';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { featureConfig } from 'modules/common/featureConfig';

export const useMaintenanceDialog = () => {
  const { isLoggedIn } = useAuth();

  const {
    isOpened: isMaintenanceDialogOpened,
    onClose: handleMaintenanceDialogClose,
    onOpen: handleMaintenanceDialogOpen,
  } = useDialog();

  const hasMaintenanceDialogFlag = hasMaintenanceDialogBeenShown();

  useEffect(() => {
    const shouldOpenMaintenanceDialog =
      isLoggedIn &&
      !hasMaintenanceDialogFlag &&
      featureConfig.notificationDialog;

    if (shouldOpenMaintenanceDialog) {
      handleMaintenanceDialogOpen();
    }
  }, [isLoggedIn, hasMaintenanceDialogFlag, handleMaintenanceDialogOpen]);

  const handleClose = useCallback(() => {
    setMaintenanceDialogAsShown();
    handleMaintenanceDialogClose();
  }, [handleMaintenanceDialogClose]);

  return {
    isOpened: isMaintenanceDialogOpened,
    onClose: handleClose,
  };
};
